import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Server, LogOut, User as UserIcon } from "lucide-react";
import BalanceWidget from "@/components/BalanceWidget";

const navItems = [
  { to: "/catalog?subtype=vps", label: "SERVERS" },
  { to: "/catalog?category=api_services", label: "APIS" },
  { to: "/pricing", label: "PRICING" },
  { to: "/about", label: "ABOUT" },
  { to: "/contact", label: "CONTACT" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-black/80 border-b border-zinc-800"
    >
      <div className="container-pad flex items-center justify-between h-16">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
          <span className="inline-flex h-8 w-8 items-center justify-center bg-signal text-black rounded-sm">
            <Server size={16} strokeWidth={2.5} />
          </span>
          <span className="font-display tracking-tight text-lg">
            Cloud<span className="text-signal">Rent</span>
            <span className="ml-2 badge-mono">VPS</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((it) => (
            <NavLink
              key={it.label}
              to={it.to}
              data-testid={`nav-${it.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-mono text-xs tracking-widest px-3 py-1.5 rounded-sm transition-colors ${
                  isActive ? "text-white bg-zinc-900" : "text-zinc-400 hover:text-white"
                }`
              }
              end={it.to === "/catalog"}
            >
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {user && user.id ? (
            <>
              <BalanceWidget variant="navbar" />
              {user.role === "admin" && (
                <Link
                  to="/admin"
                  data-testid="nav-admin"
                  className="hidden sm:inline-flex items-center gap-1 font-mono text-xs tracking-widest text-signal hover:text-white px-2 py-1.5 border border-signal/40 rounded-sm hover:border-signal transition-colors"
                  title="Admin panel"
                >
                  ADMIN
                </Link>
              )}
              <Link
                to="/dashboard"
                data-testid="nav-dashboard"
                className="hidden sm:inline-flex items-center gap-2 font-mono text-xs tracking-widest text-zinc-300 hover:text-white px-3 py-1.5"
              >
                <UserIcon size={14} /> {user.name?.toUpperCase() || "DASHBOARD"}
              </Link>
              <button
                data-testid="logout-button"
                onClick={async () => {
                  await logout();
                  nav("/");
                }}
                className="btn-ghost h-9 px-3 text-xs font-mono tracking-widest"
              >
                <LogOut size={14} /> LOGOUT
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login"
                className="font-mono text-xs tracking-widest text-zinc-400 hover:text-white px-3 py-1.5"
              >
                LOGIN
              </Link>
              <Link to="/register" data-testid="nav-register" className="btn-signal h-9 px-4 text-xs font-mono tracking-widest">
                CREATE ACCOUNT
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
